<template>
  <span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="tw-h-full tw-w-full"
      viewBox="0 0 24 24"
      :fill="strokeColor"
    >
      <path
        d="M18.75 5.25L5.25 18.75"
        stroke="white"
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.75 18.75L5.25 5.25"
        stroke="white"
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</template>
<script>
export default {
  name: 'Close',
  props: {
    strokeColor: {
      type: String,
      default: 'none',
    },
  },
};
</script>
